"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Matchers = void 0;
var Option_1 = require("fp-ts/Option");
var monocle_ts_1 = require("monocle-ts");
/**
 *  @since 0.0.1
 */
var Matchers = function (tag) { return function (keys) {
    var match = function (match, def) { return function (a) { return (match[a[tag]] || def)(a); }; };
    var matchLens = function (cases) {
        return new monocle_ts_1.Lens(function (s) { return cases[s[tag]].get(s); }, function (a) { return function (s) { return cases[s[tag]].set(a)(s); }; });
    };
    var matchOptional = function (cases) {
        return new monocle_ts_1.Optional(function (s) {
            var optionalCase = cases[s[tag]];
            return optionalCase !== undefined ? optionalCase.getOption(s) : Option_1.none;
        }, function (a) { return function (s) {
            var optionalCase = cases[s[tag]];
            return optionalCase !== undefined ? optionalCase.set(a)(s) : s;
        }; });
    };
    var transform = function (match) { return function (a) {
        var c = match[a[tag]];
        return c ? c(a) : a;
    }; };
    var fold = function (a) { return a; };
    var createReducer = function (initialState) { return function (m, def) {
        var matcher = match(m, def || (function (_a) { return function (s) { return s; }; }));
        return function (s, a) {
            var state = s === undefined ? initialState : s;
            return a[tag] in keys ? matcher(a)(state) : state;
        };
    }; };
    return {
        matchStrict: match,
        match: match,
        transform: transform,
        fold: fold,
        createReducer: createReducer,
        createPartialReducer: createReducer,
        strict: function (a) { return a; },
        matchLens: matchLens,
        matchOptional: matchOptional
    };
}; };
exports.Matchers = Matchers;
